import { createFileRoute } from '@tanstack/react-router'

import { GetStarted } from '@/containers/GetStarted'
import { trackOnboardingStart } from '@/lib/mixpanel'

export const Route = createFileRoute('/_unauthenticated/setup/')({
  component: GetStarted,
  onEnter: () => trackOnboardingStart(),
})
